import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import * as DKFDS from "dkfds";
import { AuthorityVm } from '../../Models/AuthorityVm';
import { AuthorityOrderCountVm } from '../../Models/AuthorityOrderCountVm';
import { ControlCardVm } from '../../Models/ControlCardVm';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import URL from '../../Constants/URL.js';
import { CardOrderControlCard } from '../../Models/CardOrderControlCard'
import { DateFormatter } from '../../components/HelperComponents/DateFormatter';
import ImageCrop from '../../components/HelperComponents/ImageCrop/ImageCrop'
import { formatAddress } from '../../components/HelperComponents/AddressFormatter.js';
import { OfficerVm } from '../../Models/OfficerVm';
import { getEkspeditionsType, isCardStatusValidForRenewal, localDateToUtcDate, sortCardTableByDate } from '../../components/HelperComponents/Helpers.js';
import { checkIfCardExpired, checkIfCardExpiresWitihinTwoMonths } from '../../components/HelperComponents/ValidityDateHelpers.js';
import { GetStatusName, GetStatusVm } from '../../components/HelperComponents/StatusHelper';
import { filterCardStatusesRenewed, filterCardStatusesReplaced } from '../../components/HelperComponents/FilterCardStatuses';

enum orderType {
    foerstegangsudstedelse = "Førstegangsudstedelse",
    nyudstedelse = "Nyudstedelse",
    fornyelse = "Fornyelse",
    erstatning = "Erstatning",
    udskiftning = "Udskiftning"
};

type Props = {};

type State = {
    authorities: AuthorityVm[],
    officer: OfficerVm | null,

    authInput: string,
    authority: AuthorityVm | null,
    lastSelectedAuthority: string | null,
    image: string, // Base64

    orderType: orderType,
    previousCard: ControlCardVm,
    previousCardStatus: string,

    searchButtonPressed: boolean,
    orderButtonPressed: boolean,

    expressDelivery: boolean,
    placeOfDispatch: string,
    selectedCard: ControlCardVm | null,

    pictureTooBig: boolean,
    showImageCropper: boolean,

    showSpinner: boolean,
    openModal: boolean,
    openWrxModal: boolean,
    validTo: Date | null,
    validFrom: Date | null,
    newestCardNotValidYet: boolean,

    controlCards: ControlCardVm[],
    isAuthorityOrderCountReached: boolean,
    isAuthorityOrderCountReachedErrorShown: boolean
};

export class CreateControlCard extends Component<Props, State> {
    static displayName = CreateControlCard.name;
    private toastRef: React.RefObject<any>;

    constructor(props: Props) {
        super(props);
        this.toastRef = React.createRef();

        this.state = {
            authorities: [],
            officer: null,

            authInput: "",
            authority: null,
            lastSelectedAuthority: null,
            image: "", // Base64

            orderType: orderType.foerstegangsudstedelse,
            previousCard: new ControlCardVm(),
            previousCardStatus: "",

            searchButtonPressed: false,
            orderButtonPressed: false,

            expressDelivery: false,
            placeOfDispatch: "",
            selectedCard: null,

            pictureTooBig: false,
            showImageCropper: false,

            showSpinner: false,
            openModal: false,
            openWrxModal: false,
            validTo: null,
            validFrom: null,
            newestCardNotValidYet: false,

            controlCards: [],
            isAuthorityOrderCountReached: false,
            isAuthorityOrderCountReachedErrorShown: false
        };
    }

    componentDidMount() {
        DKFDS.init();
        this.fetchOfficer();
        this.fetchAuthorities();
        this.setValidityPeriod()
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>): void {
        if (prevState.orderType !== this.state.orderType || prevState.selectedCard !== this.state.selectedCard) {
            if (prevState.selectedCard !== this.state.selectedCard) {
                this.setState({ orderType: this.getRadiobuttons()[0] }, () =>
                    this.setValidityPeriod())
            }
            else {
                this.setValidityPeriod()
            }
        }
    }

    clearPage(clearInput: boolean) {
        this.setState({
            authInput: clearInput ? "" : this.state.authInput,
            authority: clearInput ? null : this.state.authority,
            image: "", // Base64

            orderType: orderType.foerstegangsudstedelse,
            previousCard: new ControlCardVm(),
            previousCardStatus: "",

            searchButtonPressed: false,
            orderButtonPressed: false,

            expressDelivery: false,
            placeOfDispatch: "",
            selectedCard: null,

            pictureTooBig: false,
            showImageCropper: false,

            showSpinner: false,
            openModal: false,
            newestCardNotValidYet: false,

            controlCards: [],
        });
    }

    isPreviousCardStatusValid() {
        var ordertypesWithStatusChange = [orderType.erstatning, orderType.fornyelse, orderType.udskiftning]
        if (ordertypesWithStatusChange.includes(this.state.orderType)) {
            return this.state.previousCardStatus.length > 0
        }
        return true
    }

    validateOrder() {
        this.setState({ orderButtonPressed: true })
        
        if (this.state.controlCards.length === 0 && this.state.isAuthorityOrderCountReached) {
            this.showErrorToast("Bestillingslimit nået", "Du kan ikke oprette nye kontrolkort for denne myndighed.");
            return;
        };

        if (!this.state.searchButtonPressed) {
            this.showErrorToast("Fejl", "Du har ikke søgt efter eksisterende kort.")
            return
        }

        let orderIsValid: boolean = true;
        let errorMessage: string[] = [];

        if (!this.state.officer?.WrxNummer) {
            errorMessage.push("ID-nummer")
            orderIsValid = false
        }
        if (!this.state.authority) {
            errorMessage.push("myndighed")
            orderIsValid = false
        }
        if (!this.state.image) {
            errorMessage.push("billede")
            orderIsValid = false
        }
        if (!this.isPreviousCardStatusValid()) {
            errorMessage.push("ny status på tidligere kort")
            orderIsValid = false;
        }

        if (orderIsValid) {
            this.setState({ openModal: true })
        }
        else {
            this.showValidationErrorToast(errorMessage)
        }
    }

    showValidationErrorToast(errorMessage: string[]) {
        errorMessage[0] = errorMessage[0].charAt(0).toUpperCase() + errorMessage[0].slice(1);
        var errorString = errorMessage.reduce(function (p, d, i) {
            return p + (i === errorMessage.length - 1 ? ' og ' : ', ') + d;
        });
        errorString += " mangler."
        this.toastRef.current.show("Se bestilling", errorString, "error")
    }

    createOrder() {
        var model = new CardOrderControlCard()

        model.KortType = "K";
        model.OrdreType = this.state.expressDelivery ? "1" : "0";
        model.SendTilEkspeditionssted = false;
        model.GebyrFrit = true;
        model.UdstedelsesDato = new Date();
        model.EkspeditionsType = getEkspeditionsType(this.state.orderType);
        model.FotoData = this.state.image;

        model.GyldighedStartDato = localDateToUtcDate(this.state.validFrom);
        model.UdloebsDato = localDateToUtcDate(this.state.validTo);

        if (this.state.selectedCard && this.state.orderType !== orderType.foerstegangsudstedelse) {
            model.KortNrTidligereKort = this.state.selectedCard.CardNumber;
        }

        if (this.state.officer) {
            model.WrxNummer = this.state.officer.WrxNummer;
        } else {
            this.showErrorToast("Fejl ved bestilling", "ID-nummer mangler");
        }
        if (this.state.authority) {
            model.PolitiMyndighed = this.state.authority?.AuthorityCode;
            model.UdstedendeMyndighed = this.state.authority?.AuthorityCode;
        } else {
            this.showErrorToast("Fejl ved bestilling", "Myndighed mangler");
        }

        model.IsAndenGeneration = "true";
        model.Antal = "1";

        this.sendOrder(model);
    }

    sendOrder(model: CardOrderControlCard) {
        fetch(URL + "/api/controlcard/createOrder/", {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(model)
        })
            .then(response => response.json())
            .then((result) => {
                if (result.valid) {
                    if (this.state.orderType !== orderType.foerstegangsudstedelse) { this.setStatusOfPreviousCard() }
                    this.clearPage(true)
                    this.showSuccessToast("Bestilling gemt.")
                    this.setState({ openModal: false })
                }
                else if (result.errors.length > 0) {
                    this.showErrorToast(result.errors[0].exception, result.errors[0].message)
                }
                else
                    this.showErrorToast("error", "")

            })
            .catch(error => console.error(error));
    }

    setStatusOfPreviousCard() {
        let model = Object.assign({}, this.state.selectedCard);
        model.Status = GetStatusVm(this.state.previousCardStatus)

        let success = true;

        let requestInfo = {
            method: "POST",
            headers: {
                'Content-Type': "application/json"
            },
            body: JSON.stringify(model)
        }

        fetch(URL + "/api/controlcard/ChangeCardStatus", requestInfo)
            .then(response => response.json())
            .then((result) => {
                if (!result.valid) {
                    success = false
                }
            })
            .catch(() => success = false)
            .finally(
                () => {
                    if (!success) this.showErrorToast("Fejl", `Status på tidligere kort (${model.CardNumber}) blev ikke opdateret.`)
                }
            )
    }

    fetchAuthorities() {
        fetchModel("GET", URL + "/api/search/GetActiveAuthorities", "", AuthorityVm)
            .then(model => {
                this.setState({ authorities: model })
            })
            .catch(error => {
                this.showErrorToast("Fejl", "Kunne hente myndigheder, prøv igen senere.")
            })
    }

    fetchAuthorityOrderCount(authorityCode: string) {
        fetchModel("GET", URL + "/api/search/GetMyndighedBestillingCount", authorityCode, AuthorityOrderCountVm)
            .then(model => {
                const authorityOrderCountReached = model && model.length > 0 && model[0].IsAuthorityOrderCountReached;
                this.setState({ isAuthorityOrderCountReached: authorityOrderCountReached });
                this.fetchCards(authorityOrderCountReached);
            })
            .catch(error => {
                this.setState({ isAuthorityOrderCountReached: false });
                this.fetchCards(false);
            });
    }

    fetchOfficer() {
        var uuid = global.config.puuid
        if (uuid) {
            fetchModel("GET", URL + "/api/officer/GetOfficerByMitIdUuid", uuid, OfficerVm)
                .then(model => {
                    if(model[0].WrxNummer.length < 1) {
                        this.setState({ openWrxModal: true })
                        return;
                    }
                    this.setState({ officer: model[0] })
                })
                .catch(error => {
                    if (error === "No result") {
                        this.setState({ openWrxModal: true })
                    } else {
                        this.showErrorToast("Fejl", "Kunne ikke forbinde til databasen, prøv igen senere.")
                    }
                })
        } else {
            this.showErrorToast("MitID", "Der er sket en fejl ved indlæsning dine login-oplysninger.")
        }
    }

    saveWRX(wrx: string) {
        var newOfficer = new OfficerVm()
        newOfficer.MitIdUuid = global.config.puuid
        newOfficer.WrxNummer = wrx

        fetch(URL + "/api/officer/SaveOfficer/", {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(newOfficer)
        })
            .then(response => response.json())
            .then((result) => {
                if (result.valid) {
                    if (this.state.orderType !== orderType.foerstegangsudstedelse) { this.setStatusOfPreviousCard() }
                    this.clearPage(true)
                    this.showSuccessToast("Dit ID-nummer er nu tilknyttet dit NemLogin.")
                    this.fetchOfficer()
                }
                else if (result.errors.length > 0) {
                    this.showErrorToast(result.errors[0].exception, result.errors[0].message)
                }
                else
                    this.showErrorToast("Fejl", "")

            })
            .catch(error => console.error(error));
    }

    fetchCards(authorityOrderCountReached: boolean = false) {
        if (this.state.officer?.WrxNummer && this.state.authority) {
            this.setState({ searchButtonPressed: true }, () => {
                this.setState({ showSpinner: true });
                fetchModel("GET", URL + "/api/controlcard/GetControlCardsByWrxNrAndPoliceAutNr", `?wrxNr=${this.state.officer?.WrxNummer}&policeAuthNr=${this.state.authority?.AuthorityCode}`, ControlCardVm)
                    .then(model => {
                        this.handleControlCardSearchResults(model, authorityOrderCountReached)
                    })
                    .catch(error => {
                        if (error !== "No result") {
                            this.showErrorToast(error ? error : "Fejl", "Der skete en fejl under søgning efter kontrolkort.");
                            this.setState({ searchButtonPressed: false })
                        }
                        else {
                            this.handleControlCardSearchResults([], authorityOrderCountReached)
                        }
                    })
                    .finally(() => {
                        this.setState({ showSpinner: false })
                    })
            })
        } else {
            this.showErrorToast("Fejl", "Myndighed eller ID-nummer mangler.")
        }
    }

    handleControlCardSearchResults(cards: ControlCardVm[], authorityOrderCountReached: boolean = false) {
        cards = sortCardTableByDate(cards);

        this.setState({
            controlCards: cards,
            newestCardNotValidYet: cards.length > 0 && cards[0].ValidFrom ? new Date(cards[0].ValidFrom) > new Date() : false,
            orderType: this.getRadiobuttons()[0]
        }, () => {
            if (cards.length === 0 && authorityOrderCountReached) {
                this.showWarningToast("Bestillingslimit nået. Du kan ikke oprette nye kontrolkort for denne myndighed.");
            }
        })
    }

    getSelectedCard(cardNumber: string): ControlCardVm | null {
        return this.state.controlCards.find(card => card.CardNumber === cardNumber) ?? null
    }

    onRowSelected(row: string[]) {
        let card = row ? this.getSelectedCard(row[0]) : null
        this.setState({ selectedCard: card }, () => {
            this.setState({ orderType: this.getRadiobuttons()[0] },
                () => this.setValidityPeriod()
            )
        })
    }

    setValidityPeriod() {
        let newValidFrom: Date | null = null
        let newValidTo: Date | null = null
        switch (this.state.orderType) {
            case orderType.foerstegangsudstedelse:
            case orderType.nyudstedelse:
                newValidFrom = new Date()
                newValidTo = new Date()
                newValidTo.setFullYear(newValidTo.getFullYear() + 2)
                newValidTo.setDate(newValidTo.getDate() - 1)
                break;
            case orderType.fornyelse:
                if (checkIfCardExpired(this.state.selectedCard)) {
                    newValidFrom = new Date()
                } else {
                    newValidFrom = new Date(this.state.selectedCard?.ValidTo ?? -1)
                    newValidFrom.setDate(newValidFrom.getDate() + 1)
                }
                newValidTo = new Date(newValidFrom)
                newValidTo.setFullYear(newValidFrom.getFullYear() + 2)
                newValidTo.setDate(newValidTo.getDate() - 1)
                break;
            case orderType.erstatning:
                newValidFrom = new Date(Math.max(Number(new Date()), Number(new Date(this.state.selectedCard?.ValidFrom ?? -1))))
                newValidTo = new Date(this.state.selectedCard?.ValidTo ?? -1)
                break;
            case orderType.udskiftning:
                newValidFrom = new Date(Math.max(Number(new Date()), Number(new Date(this.state.selectedCard?.ValidFrom ?? -1))))
                newValidTo = new Date()
                newValidTo.setFullYear(newValidTo.getFullYear() + 2)
                newValidTo.setDate(newValidTo.getDate() - 1)
                break;
            default:
        }
        this.setState({ validFrom: newValidFrom, validTo: newValidTo })
    }

    getRadiobuttons() {
        const authorityOrderCountReached = this.state.isAuthorityOrderCountReached;

        if (this.state.controlCards.length > 0) {
            if (!this.state.selectedCard) {
                return []
            }
            if (this.state.selectedCard.ValidFrom ? new Date(this.state.selectedCard.ValidFrom) < new Date() : false) {
                if (checkIfCardExpired(this.state.selectedCard)) {
                    return [orderType.fornyelse]
                }
                else if (checkIfCardExpiresWitihinTwoMonths(this.state.selectedCard)) {
                    return [orderType.fornyelse, orderType.erstatning, orderType.udskiftning]
                }
            }
            return [orderType.erstatning, orderType.udskiftning]
        }

        return authorityOrderCountReached ? [] : [orderType.foerstegangsudstedelse]
    }

    setAuthority(auth: string) {
        if (this.state.lastSelectedAuthority === auth) {
            return;
        };

        var authority = this.state.authorities.find(a => auth.includes(a.AuthorityCode)) ?? null;

        this.setState({
            authInput: auth,
            authority: authority,
            lastSelectedAuthority: auth,
            isAuthorityOrderCountReached: false,
            controlCards: [],
            selectedCard: null,
            previousCardStatus: "",
            searchButtonPressed: false,
            orderButtonPressed: false
        }, () => {
            if (authority) {
                this.fetchAuthorityOrderCount(authority.AuthorityCode);
            }
        });
    }

    setImage(img: string | undefined) {
        if (img) {
            if (new Blob([img]).size > 1.99e+6) { // Antal bytes svarende til 1.99 MB
                img = ""
                this.showWarningToast(`Billedet er for stort, prøv at beskære det anderledes.`)
                this.setState({ pictureTooBig: true })
            } else {
                this.setState({ pictureTooBig: false })
            }
            this.setState({ image: img })
        }
    }

    checkCardValidForRenewal(card: ControlCardVm) {
        return isCardStatusValidForRenewal(card.Status.Id)
    }

    checkboxDisabled(i: number) {
        if (this.state.newestCardNotValidYet) {
            return !((i === 0 || i === 1) && this.state.controlCards.length > 1)
        }
        return true
    }

    showSuccessToast(message: string) {
        this.toastRef.current.show("Success", message, "success")
    }

    showErrorToast(title: string, message: string) {
        this.toastRef.current.show(title, message, "error")
    }

    showWarningToast(message: string) {
        this.toastRef.current.show("Advarsel", message, "warning")
    }

    render() {
        return (
            <>
                <Fstyr.Toast ref={this.toastRef} />
                <Fstyr.BetjentModal
                    show={!Boolean(this.state.officer) && this.state.openWrxModal}
                    onAccept={(wrx: string) => this.saveWRX(wrx)}
                />
                <Fstyr.Modal
                    show={this.state.openModal}
                    onDecline={() => { this.setState({ openModal: false }) }}
                    onAccept={() => { this.createOrder() }}
                    label="Bestil kontrolkort"
                    buttonGroupLabel="Bestil kontrolkort"
                    buttonAcceptLabel="Bestil"
                    buttonDeclineLabel="Annullér"
                    layout={[
                        {
                            "label": "Virksomhedsinformationer",
                            "inputs": [
                                { "label": "ID-nummer", "value": this.state.officer?.WrxNummer },
                                { "label": "Myndighed", "value": this.state.authority?.PlaceOfIssue },
                                { "label": "Myndighedsadresse", "value": formatAddress(this.state.authority?.Address, true) }
                            ]
                        },
                        {
                            "label": "Bestillingsinformationer",
                            "inputs": [
                                { "label": "Type", "value": this.state.orderType },
                                { "label": "Antal kort", "value": 1 },
                                { "label": "Gyldighedsperiode", "value": DateFormatter(this.state.validFrom) + " til " + DateFormatter(this.state.validTo) },
                                { "label": "Ekspreslevering", "value": this.state.expressDelivery ? "Ja" : "Nej" },
                            ]
                        }
                    ]}
                />
                <Fstyr.Segment
                    title="Opret Kontrolkort"
                    isPageTitle={true}
                >
                    <div className="fstyr-right-top-button-group">
                        <Fstyr.Button
                            label="Ryd side"
                            onClick={() => { this.clearPage(true) }}
                        />
                    </div>
                </Fstyr.Segment>
                <Fstyr.Segment title="Myndighedsinformation">
                    <Fstyr.Input
                        label={"ID-nummer"}
                        readonly={true}
                        value={this.state.officer?.WrxNummer ?? ""}
                        direction="column"
                    />

                    <div className={(this.state.orderButtonPressed && !this.state.authority) ? "form-group form-error" : ""}>
                        <Fstyr.Dropdown
                            label="Vælg myndighed"
                            items={this.state.authorities.map(auth => `${auth.PlaceOfIssue} (${auth.AuthorityCode})`)}
                            width={300}
                            initialValue={this.state.authInput}
                            onItemSelected={(item: string) => this.setAuthority(item)}
                            autocomplete={true}
                        />
                        {(this.state.orderButtonPressed && !this.state.authority) &&
                            <span className="form-error-message" id="form-error-error">
                                {"Myndighed mangler."}
                            </span>
                        }
                    </div>

                    <div className="fstyr-left-button-group">
                        <div className={(!this.state.searchButtonPressed && this.state.orderButtonPressed) ? "form-group form-error" : ""}>
                            <Fstyr.Button
                                label="Søg"
                                onClick={() => {
                                    this.fetchCards()
                                }}
                                disabled={this.state.showSpinner}
                            />
                            <Fstyr.Spinner
                                show={this.state.showSpinner}
                            />
                            {(!this.state.searchButtonPressed && this.state.orderButtonPressed) &&
                                <span className="form-error-message" id="form-error-error">
                                    {"Du skal søge efter eksisterende kort."}
                                </span>
                            }
                        </div>
                    </div>
                </Fstyr.Segment>
                <Fstyr.Segment title="Kortoplysninger">
                    <div className="fstyr-attention-box" >
                        <p>Myndighedsoplysninger</p>
                        <Fstyr.Input
                            label={"Navn"}
                            readonly={true}
                            value={this.state.authority?.PlaceOfIssue ? this.state.authority?.PlaceOfIssue : ""}
                            direction="row"
                        />
                        <Fstyr.Input
                            label={"Adresse"}
                            readonly={true}
                            value={formatAddress(this.state.authority?.Address)}
                            direction="row"
                        />
                    </div>
                </Fstyr.Segment>
                <Fstyr.Segment title="Registreret kontrolkort">
                    <Fstyr.SelectableTable
                        label="Resultater"
                        headers={["Kortnr.", "Startdato", "Udløbsdato", "Status"]}
                        data={this.state.controlCards.map(function (card) {
                            return [
                                card.CardNumber,
                                DateFormatter(card.ValidFrom),
                                DateFormatter(card.ValidTo),
                                GetStatusName(card.Status.NameDK)
                            ]
                        })}
                        note={this.state.searchButtonPressed ? `Du har ${this.state.controlCards.length} kontrolkort hos denne myndighed.` : "Du har ikke søgt efter kort."}
                        onRowSelected={(row: string[]) => this.onRowSelected(row)}
                        useCustomDisableCheckboxFunction={true}
                        disableCheckbox={(index) => this.checkboxDisabled(index)}
                        preSelect
                        noDeselection
                    />
                </Fstyr.Segment>

                {!(this.state.controlCards.length === 0 && this.state.isAuthorityOrderCountReached) && (
                    <>
                        <Fstyr.Segment title="Billede">
                            <div className={((!this.state.image && this.state.orderButtonPressed) || this.state.pictureTooBig) ? "form-group form-error" : ""}>
                                <ImageCrop
                                    onCut={(value) => this.setImage(value)}
                                    showComponent={this.state.showImageCropper}
                                    setShowComponent={(value: boolean) => this.setState({ showImageCropper: value })}
                                />
                                {(!this.state.image && this.state.orderButtonPressed) &&
                                    <span className="form-error-message" id="form-error-error">
                                        {"Et billede skal vælges og beskæres"}
                                    </span>
                                }
                                {(this.state.pictureTooBig) &&
                                    <span className="form-error-message" id="form-error-error">
                                        {"Billedet er for stort, prøv at beskære billedet anderledes."}
                                    </span>
                                }
                            </div>
                        </Fstyr.Segment>
                        <Fstyr.Segment
                            title="Bestilling"
                        >
                            <Fstyr.RadioButtonGroup
                                label="Angiv type af bestilling"
                                choices={this.getRadiobuttons()}
                                value={this.state.orderType}
                                onClick={(value: string) => this.setState({ orderType: value as orderType })}
                            />
                            {/*Status på tidligere kort*/}
                            <div className={(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) ? "form-group form-error" : ""}>

                                {(this.state.orderType === orderType.fornyelse || this.state.orderType === orderType.udskiftning) &&
                                    <Fstyr.Dropdown
                                        items={filterCardStatusesRenewed(require('../../assets/CardStatus.json'))}
                                        width={320}
                                        onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                                        label="Status på tidligere kort"
                                    />
                                }
                                {
                                    (this.state.orderType === orderType.erstatning) &&
                                    <Fstyr.Dropdown
                                        items={filterCardStatusesReplaced(require('../../assets/CardStatus.json'))}
                                        width={320}
                                        onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                                        label="Status på tidligere kort"
                                    />
                                }
                                {(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) && (
                                    <span className="form-error-message" id="form-error-error">
                                        {"Status skal udfyldes"}
                                    </span>
                                )}
                            </div>
                            {/* {(this.state.orderType !== orderType.foerstegangsudstedelse) && (
                        <div>
                            <p className="fstyr-text-header">Leveringsinformation</p>
                            <Fstyr.Checkbox
                                label="Ekspreslevering"
                                checked={this.state.expressDelivery}
                                onClick={(value: boolean) => this.setState({ expressDelivery: value })}
                            />
                        </div>)} */}
                        </Fstyr.Segment>
                        <Fstyr.Segment
                            title="Bestillingsinformation"
                        >
                            <Fstyr.Button
                                label="Se bestilling"
                                onClick={() => this.validateOrder()}
                            />
                        </Fstyr.Segment>
                    </>
                )}
            </>
        );
    }
}